(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1430],{

/***/ 31721:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/browse",
      function () {
        return __webpack_require__(2115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HeadlineBanner */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: var(--primary-base);\n  color: var(--text-invert);\n  margin-bottom: 3rem;\n\n  .headline {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var HeadlineBanner = function(param) {
    var title = param.title, subtitle = param.subtitle, _wide = param.wide, wide = _wide === void 0 ? false : _wide, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeadlineBanner, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "inner ".concat(wide ? "" : "small-", "outer-padding")),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "headline",
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: subtitle
                    })
                ]
            })
        })
    });
};
var StyledHeadlineBanner = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc859481-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (HeadlineBanner);


/***/ }),

/***/ 18707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_global_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72265);



var Settings = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_global_context__WEBPACK_IMPORTED_MODULE_2__/* .GlobalContext */ .k), theme = ref.theme, setTheme = ref.setTheme;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(theme === "light" ? false : true), isChecked = ref1[0], setIsChecked = ref1[1];
    var handleChange = function() {
        return setIsChecked(!isChecked);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var theme = localStorage.getItem("continia.theme");
        if (theme) {
            setIsChecked(theme === "dark");
            setTheme(theme === "dark" ? "dark" : "light");
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        localStorage.setItem("continia.theme", isChecked ? "dark" : "light");
        setTheme(isChecked ? "dark" : "light");
    }, [
        isChecked,
        setTheme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-end align-center items-center ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-20 flex justify-end align-center items-center mr-2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Settings);


/***/ }),

/***/ 13302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ master_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/breadcrumb.tsx
var components_breadcrumb = __webpack_require__(87607);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/library/header.tsx + 3 modules
var header = __webpack_require__(60257);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./utils/i18n.ts + 3 modules
var i18n = __webpack_require__(87161);
// EXTERNAL MODULE: ./components/tailwind-m/settings.tsx
var settings = __webpack_require__(18707);
;// CONCATENATED MODULE: ./components/tailwind-m/footer.tsx







var LandingSignin = function() {
    var locale = (0,router.useRouter)().locale;
    var footerlinks = i18n/* default */.Z[locale || "en-US"].footerlinks;
    var keys = (0,react.useMemo)(function() {
        return footerlinks.map(function() {
            return (0,v4/* default */.Z)();
        });
    }, [
        footerlinks
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-footer w-full h-nav flex justify-center border-t border-border",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full flex items-center justify-between outer-padding",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(settings/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-wrap gap-x-10 items-center",
                    children: footerlinks.map(function(link, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm text-textRegular flex items-center font-normal",
                                        children: link.name
                                    })
                                })
                            })
                        }, keys[index]);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var footer = (LandingSignin);

;// CONCATENATED MODULE: ./layouts/master-layout.tsx

/* eslint-disable @typescript-eslint/no-empty-function */ 







var Layout = function(param) {
    var children = param.children, breadcrumb = param.breadcrumb, title = param.title, description = param.description, mainClassName = param.mainClassName;
    var isPreview = (0,router.useRouter)().isPreview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=Edge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "last-build",
                        content: new Date().toISOString()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {}),
            console.log("breadcrumb", breadcrumb),
            breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "breadcrumb outer-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_breadcrumb/* default */.Z, {
                    breadcrumb: breadcrumb
                })
            }),
            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "preview-warning",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "You are in preview mode"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/api/editor/clear-preview-data",
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "Clear Cookies"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main-content",
                className: classnames_default()(mainClassName),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var master_layout = (Layout);


/***/ }),

/***/ 2115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BrowseAllPage": function() { return /* binding */ BrowseAllPage; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var layouts_master_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13302);
/* harmony import */ var components_headline_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60611);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59830);
/* harmony import */ var components_product_card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23942);
/* harmony import */ var styles_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64014);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 3rem;\n\n  .tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    margin: 1rem 0;\n  }\n\n  .product-grid {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 1rem;\n\n    ",
        " {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    ",
        " {\n      grid-template-columns: repeat(3, 1fr);\n    }\n    /* ",
        " {\n      grid-template-columns: repeat(4, 1fr);\n    } */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var __N_SSG = true;
var BrowseAllPage = function(param) {
    var frontpage = param.frontpage, items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(layouts_master_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        breadcrumb: [],
        title: frontpage.meta.title,
        description: frontpage.meta.description,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_headline_banner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                wide: true,
                title: frontpage.title,
                subtitle: frontpage.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBrowseAll, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "outer-padding modules-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                            className: "tags",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        size: "small",
                                        mode: "primary",
                                        linkProps: {
                                            href: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_LEARN */ .sJ, "/browse")
                                        },
                                        children: "Browse all"
                                    })
                                }),
                                utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .products.map */ .RB.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            size: "small",
                                            mode: "secondary",
                                            linkProps: {
                                                href: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_LEARN */ .sJ, "browse/").concat(item.slug)
                                            },
                                            children: item.title
                                        })
                                    }, item.tag);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "product-grid",
                            children: items.filter(function(item) {
                                var ref;
                                return (ref = item.meta) === null || ref === void 0 ? void 0 : ref.id;
                            }).map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_product_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                    item: item,
                                    bookmarkData: item.meta.type === "Module" ? {
                                        moduleId: item.meta.id
                                    } : {
                                        learningPathId: item.meta.id
                                    }
                                }, item.meta.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var StyledBrowseAll = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-6790f902-0"
})(_templateObject(), styles_styles__WEBPACK_IMPORTED_MODULE_7__/* .mqFrom.mobile */ .wO.mobile, styles_styles__WEBPACK_IMPORTED_MODULE_7__/* .mqFrom.tablet */ .wO.tablet, styles_styles__WEBPACK_IMPORTED_MODULE_7__/* .mqFrom.desktop */ .wO.desktop);
/* harmony default export */ __webpack_exports__["default"] = (BrowseAllPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,2602,2231,5675,7161,257,2072,8729,9774,2888,179], function() { return __webpack_exec__(31721); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);